import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import ownerBillingApi from '../services/ownerBillingApi';

// «حسابات المنصات والتسجيل الضريبي» on the billing page (tasks/pricing-listing-build-brainstorm.md, slice
// 1b). Its own queries, apart from the worksheet: the box is per owner, not per month, and a failure
// here must never take the worksheet down. Every write refetches the list rather than patching it — the
// current status is a SERVER answer.

export const OTA_ACCOUNTS_KEY = (ownerId) => ['owner-billing', 'ota-accounts', ownerId];

// Retry once, and ONLY when no answer came back — a refusal is final (the useStock rule).
const retryOnlyWithoutAnswer = (failureCount, error) => !error?.response && failureCount < 1;

export const useOtaAccounts = (ownerId) =>
  useQuery({
    queryKey: OTA_ACCOUNTS_KEY(ownerId),
    queryFn: () => ownerBillingApi.getOtaAccounts(ownerId).then(res => res.data),
    enabled: Boolean(ownerId),
    retry: retryOnlyWithoutAnswer,
    staleTime: 60 * 1000
  });

const useOtaAction = (ownerId, mutationFn, retry) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn,
    retry,
    onSettled: () => queryClient.invalidateQueries({ queryKey: OTA_ACCOUNTS_KEY(ownerId) })
  });
};

// Adding a row is NOT idempotent: a retried request whose first answer was lost would save it twice.
export const useAddOtaVatChange = (ownerId) =>
  useOtaAction(ownerId, (change) => ownerBillingApi.addOtaVatChange(ownerId, change), false);

// Not retried either: a retry after a lost answer would get the server's "already withdrawn" 404 and show
// a success as an error. The list refetches on settle, so the row's real state is on screen either way.
export const useWithdrawOtaVatChange = (ownerId) =>
  useOtaAction(ownerId, ({ changeId, reason }) => ownerBillingApi.withdrawOtaVatChange(ownerId, changeId, reason), false);
